import React, { lazy, memo } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  const benefits = ['48 fichas de activación cognitiva listas para imprimir y usar', 'Ejercicios diarios para la memoria, la atención y la concentración', 'Actividades familiares para hacer juntos y construir recuerdos nuevos', 'Sistema progresivo que va de lo más simple a lo más desafiante', 'Diseñado para adultos mayores que viven en Argentina', 'Sin tecnología, sin aplicaciones, sin complicaciones'];
  return <section className="pt-3 pb-4 px-4 md:pt-24 md:pb-16 max-w-4xl mx-auto text-center" data-id="element-126">
      <p className="text-teal-700 font-semibold tracking-wide uppercase text-[10px] leading-tight md:text-base mb-2 md:mb-6" data-id="element-127">
        PARA EL QUE VE CÓMO SU PAPÁ, SU MAMÁ O SU ABUELO/A SE VA APAGANDO DE A
        POCO Y NO SABE QUÉ HACER…
      </p>

      <h1 className="text-3xl md:text-7xl font-extrabold text-slate-900 mb-1 md:mb-4 tracking-tight leading-none" data-id="element-128">
        Mente Activa
      </h1>

      <h2 className="text-sm md:text-3xl font-medium text-slate-700 mb-2 md:mb-8 leading-snug" data-id="element-129">
        El sistema completo de activación mental para adultos mayores
      </h2>

      <p className="text-xs md:text-xl text-slate-600 mb-2 md:mb-10 max-w-2xl mx-auto leading-snug md:leading-relaxed" data-id="element-130">
        En Argentina los olvidos se naturalizan. Se llaman "cosas de la edad".
        Pero hay algo que podés hacer hoy mismo.
      </p>

      <div className="mb-3 md:mb-12 max-w-[170px] md:max-w-xl mx-auto" data-id="element-131">
        <img src="https://cdn.magicpatterns.com/uploads/dmAmaJRonpVM6PTXPaMjUc/ChatGPT_Image_5_may_2026__02_08_23_p.m.-removebg-preview.png" alt="Mente Activa - Sistema de Activación Mental" loading="lazy" onClick={() => document.getElementById('checkout')?.scrollIntoView({
        behavior: 'smooth'
      })} className="w-full h-auto cursor-pointer drop-shadow-2xl hover:scale-[1.02] transition-transform duration-300" data-id="element-132" />
      </div>

      <div className="bg-white border border-orange-200 rounded-xl md:rounded-2xl p-3 md:p-8 text-left mb-6 md:mb-10 shadow-xl" data-id="element-133">
        <p className="text-center font-bold text-slate-900 mb-2 md:mb-6 text-xs md:text-lg border-b border-orange-100 pb-2 md:pb-4" data-id="element-134">
          NUEVO — 6 Tomos + 4 Bonos · Descarga inmediata
        </p>

        <ul className="space-y-1 md:space-y-4 mb-3 md:mb-8" data-id="element-135">
          {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-2 md:gap-3" data-id="element-136">
              <CheckCircle2 className="w-3.5 h-3.5 md:w-6 md:h-6 text-teal-600 shrink-0 mt-0.5" data-id="element-137" />
              <span className="text-slate-700 text-[11px] leading-tight md:text-lg md:leading-normal" data-id="element-138">
                {benefit}
              </span>
            </li>)}
        </ul>

        <div className="text-center mt-2 md:mt-8" data-id="element-139">
          <p className="text-slate-600 mb-2 md:mb-4 font-medium text-[11px] md:text-base" data-id="element-140">
            Pago único de $19.990 ARS · Acceso inmediato
          </p>
          <CTAButton text="SÍ, QUIERO MENTE ACTIVA →" className="!py-2.5 !px-4 !text-sm md:!py-4 md:!px-8 md:!text-xl" data-id="element-141" />
        </div>
      </div>
    </section>;
}